import React, {useState, useEffect} from 'react';
import useSWR from 'swr';
// import scrollScreen from 'rc-scroll-anim/lib/ScrollScreen';

import Banner3 from './components/Banner3';
import Content14 from './components/Content14';
import Feature0 from './components/Feature0';
import Feature6 from './components/Feature6';
import Teams0 from './components/Teams0';
// import Content12 from './Content12';
// import Footer1 from './components/Footer1';

import useWindowDimensions from '../../helpers/useWindowDimensions';

import {
  Banner30DataSource,
  Content14DataSource,
  Feature00DataSource,
  Feature60DataSource,
  Teams00DataSource,
  // Content120DataSource,
  // Footer10DataSource,
} from './data.source';
// import './style/antMotionStyle.scss';

// const { location } = window;

const AboutUs = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [show, setShow] = useState(false);

  const {data} = useSWR('/api/fablement/stats/count');
  const [storyCount, setStoryCount] = useState(0);
  const [readCount, setReadCount] = useState(0);
  const [userCount, setUserCount] = useState(0);
  const { width } = useWindowDimensions();

  useEffect(() => {
    if(width <= 768)
      setIsMobile(true)
    else
      setIsMobile(false)
  }, [width])

  useEffect(() => {
    window.scrollTo(0, 0)
    setTimeout(() => {
      setShow(true);
      // scrollScreen.init({
      //   location: [
      //     // 'Banner3_0',
      //     'Feature0_0',
      //     'Feature6_0',
      //     'Teams0_0',
      //     'Footer1_0',
      //   ],
      // });
    }, 500);
  }, []);


  useEffect(() => {
    if(data) {
      setStoryCount(data[0].story_count)
      setReadCount(data[0].read_count)
      setUserCount(data[0].user_account_count)
    }
  }, [data])

  // componentWillUnmount() {
  //   scrollScreen.unMount()
  // }

  const children = [
    <Banner3
      id="Banner3_0"
      key="Banner3_0"
      dataSource={Banner30DataSource}
      isMobile={isMobile}
    />,
    <Content14
        id="Content14_0"
        key="Content14_0"
        dataSource={Content14DataSource}
        isMobile={isMobile}
    />,
    <Feature0
      id="Feature0_0"
      key="Feature0_0"
      dataSource={Feature00DataSource}
      isMobile={isMobile}
    />,
    // <Feature6
    //   id="Feature6_0"
    //   key="Feature6_0"
    //   dataSource={Feature60DataSource(storyCount, readCount, userCount)}
    //   isMobile={isMobile}
    // />,
    <Teams0
      id="Teams0_0"
      key="Teams0_0"
      dataSource={Teams00DataSource}
      isMobile={isMobile}
    />,
    // <Content12
    //   id="Content12_0"
    //   key="Content12_0"
    //   dataSource={Content120DataSource}
    //   isMobile={isMobile}
    // />,
    // <Footer1
    //   id="Footer1_0"
    //   key="Footer1_0"
    //   dataSource={Footer10DataSource}
    //   isMobile={isMobile}
    // />,
  ];

  return (
    <div
      className="templates-wrapper"
      // ref={(d) => {
      //   this.dom = d;
      // }}
    >
      {show && children}
    </div>
  );
}

export default AboutUs;